document.querySelectorAll('.product-carousel').forEach(function(Element,index){
  let productid = Element.dataset.id;
  let outer_carousel = Element.closest('.related-products');
  let slider = new Splide(Element, {
    drag: 'free',
    pagination: false,
    perPage: 5,
    gap: 8,
    breakpoints: {
      991: {
        perPage: 4,
      },
      767: {
        perPage: 3,
      },
      575: {
        perPage: 2,
        autoWidth: true,
        gap: 12,
      }
    }
  }).mount();
  
  if(document.querySelectorAll('.related-tab li')){
    document.querySelectorAll('.related-tab li').forEach((tab) =>{
      let currentVal = tab.getAttribute('data-title');
      if(Element.closest('.carousel-rowouter').getAttribute('data-title') == currentVal){
        tab.addEventListener('click',function(e){
          e.preventDefault();
          e.stopImmediatePropagation();
          let tabsWithIsOpen = document.querySelectorAll(".related-tab li.active-tab");
          tabsWithIsOpen.forEach((tabWithIsOpen) => {
            tabWithIsOpen.classList.remove("active-tab");
          });
          tab.classList.add("active-tab");
          let currentCarousel = Element.closest('.carousel-rowouter').getAttribute('data-title');
          if(currentVal == currentCarousel){
            let carouselsWithIsOpen = document.querySelectorAll(".carousel-rowouter.active-carousel");
            carouselsWithIsOpen.forEach((carouselWithIsOpen) => {
              carouselWithIsOpen.classList.remove("active-carousel");
            });
            Element.closest('.carousel-rowouter').classList.add("active-carousel");
          }
          slider.refresh();
        });
      }
    });
  }
});